import React from 'react';
import { Container, Typography } from '@mui/material';
import PromptsManager from '../components/PromptsManager';

const PromptsManagerPage = () => {
    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Manage Prompts
            </Typography>
            <PromptsManager />
        </Container>
    );
};

export default PromptsManagerPage;
